// 32 bit integer mask
export const DOLLHOUSE_LAYER_DEFAULT = 1;
export const DOLLHOUSE_LAYER_BIT_DEFAULT = 0b1;
export const DOLLHOUSE_LAYER_INTERACTIVE = 15;
export const DOLLHOUSE_LAYER_BIT_INTERACTIVE = 0b1000000000000000;
